import { Outlet, createFileRoute } from '@tanstack/react-router'
import { MODEL_TRAINING_MODULE_ID } from '@/features/model-training'
import { requirePermission } from '@/shared/auth'
import { requireModule } from '@/shared/modules'

export const Route = createFileRoute('/app/model-training')({
  beforeLoad: (args) => {
    requireModule(MODEL_TRAINING_MODULE_ID)(args)
    return requirePermission('model-training:view')(args)
  },
  component: Outlet,
})
